import { createNode } from '@glueapp/graph-types';

export const GetSecret = createNode({
    id: 'Get Secret',
    name: 'Get Secret',
    description: 'Retrieves the value of a secret',
    aiDescription: [
        "Retrieves a secret value (API key, token, etc.) by selecting it from the project's secrets.",
        'Setup:',
        '1. Create the secret first: glue add-secret MY_API_KEY --description "Description"',
        '   (This registers a placeholder — the user fills in the actual value later)',
        '2. Add the node with the secret selected:',
        '   glue add GetSecret --state selectedSecret=MY_API_KEY',
        '',
        'The secret reference is resolved server-side at execution time; the actual value never appears in the graph.',
    ].join('\n'),
    category: 'Secrets',
    color: '#e6a817',
    inPorts: {
        Secret: { kind: 'secret' },
    },
    outPorts: {
        Value: { kind: 'string' },
    },
    execute(input) {
        // Runner has already resolved SecretReferenceValue -> string in portValues
        const secretValue = input.inPorts.Secret;
        return { output: { Value: typeof secretValue === 'string' ? secretValue : '' } };
    },
});
